import { useCallback } from "react";
import { useDefaultBackToSearch } from "@/contexts/classified";
import { useBrandUrl } from "./useBrandUrl";
import { useIsNewBuildProject } from "@/shared/hooks";
export const useBackToSearch = () => {
    const baseUrl = useBrandUrl();
    const isProject = useIsNewBuildProject();
    const searchPath = isProject ? "/project-search?" : "/classified-search?";
    const defaultBackToSearch = useDefaultBackToSearch();
    const trackingMedium = "&m=classified_detail_lead_confirmation_continue_last_search_classified_search_results";
    const url = `${baseUrl}${searchPath}${defaultBackToSearch}${trackingMedium}`;
    const handleBackToSearch = useCallback(() => {
        if (defaultBackToSearch) {
            window.location.href = url;
        }
        else {
            window.location.href = baseUrl;
        }
    }, [baseUrl, defaultBackToSearch, url]);
    return {
        handleBackToSearch,
    };
};
